import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { DashboardApp } from "./App";

export function mountDashboard(documentRoot: Document, pathname: string) {
  const root = documentRoot.querySelector<HTMLDivElement>("#root");
  if (!root) throw new Error("Dashboard root element is missing");

  createRoot(root).render(
    <StrictMode>
      <DashboardApp pathname={pathname} />
    </StrictMode>,
  );
}
